<template>
    <div class="d-flex min-vh-100 justify-content-center flex-column ds-background-primary">
        <div class="text-center">
          <h2 class="text-white mb-2"><img src="@/assets/ELSA_logo.png" alt="ELSA" width="460px"/></h2>
            <router-view/>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'auth',
    };
</script>